export { default as NBackTop, backTopProps } from './src/BackTop';
